export enum FilterType {
    TEXT = 'text',
    CUSTOM = 'custom',
    BOOLEAN = 'boolean',
    NUMERIC = 'numeric',
    DATE = 'date',
    SELECT = 'select',
    MULTISELECT = 'multiselect',
    AUTOCOMPLETE = 'autocomplete',
}
